var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    rx: 1.5,
    transform: "matrix(-1 0 0 1 21 15)",
    stroke: "#2C3D50",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15V12C15 11.1716 15.6716 10.5 16.5 10.5H24C24.8284 10.5 25.5 11.1716 25.5 12V19.5C25.5 20.3284 24.8284 21 24 21H21",
    stroke: "#2C3D50",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.d8818d4aa3c0592d5906bda9219d3fa8.svg";
export { ForwardRef as ReactComponent };